<template>
    <div class="components-container" id="mobileViewPort">
        <div id="mobileMode">
            <div id="queryArea">
                <div class="filter-container">
                    <div class="formItem">
                        <el-input v-model="queryForm.unitName" placeholder="实习单位名称" clearable/>
                    </div>
                    <div class="formItem text-center">
                        <el-button @click="handleFilter" type="gray"><i class="el-icon-search"></i></el-button>
                        <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i></el-button>
                        <el-button @click="queryDialogVisible = true" type="primary"><i class="el-icon-more"></i>
                        </el-button>
                        <el-button @click="addRec" type="success"><i class="el-icon-circle-plus-outline"></i>
                        </el-button>
                        <el-button @click="batchExportDialogVisible = true" type="primary"><i
                            class="el-icon-download"></i></el-button>
                    </div>
                </div>
            </div>

            <!-- 搜索内容弹框 -->
            <el-dialog id="queryDialog" class="formDialog" title="查询信息" width="90%" :visible.sync="queryDialogVisible">
                <el-row>
                    <el-input v-model="queryForm.unitName" placeholder="实习单位名称"/>
                </el-row>
                <el-row>
                    <el-input v-model="queryForm.postName" placeholder="实习岗位名称"/>
                </el-row>
                <div slot="footer" class="dialog-footer text-center">
                    <el-button type="gray" @click="handleFilter">查 询</el-button>
                    <el-button style="margin-left: 10px;" type="gray" @click="handleReset">重 置</el-button>
                    <el-button style="margin-left: 10px;" @click="queryDialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

            <div id="listArea" @scroll="handleScroll" :style="{'height': divHeight-110+'px','overflow': 'auto'}">
                <div v-if="tableData==null || tableData.length==0" class="cardTips">没有现场指导记录</div>
                <div class="cardMain" v-for="(item,index) in tableData" :key="index">
                    <div class="cardText">
                        <p><label for="">实习单位：</label>{{ item.unitName }}</p>
                        <p><label for="">实习岗位：</label>{{ item.postName }}</p>
                        <p><label for="">指导老师：</label>{{ item.teaName }}</p>
                        <p><label for="">指导时间：</label>{{ item.recordDate }}</p>
                    </div>
                    <div class="cardInput">
                        <el-button type="warning" size="small" @click="modRec(item)">编辑</el-button>
                        <el-button type="danger" size="small" @click="delRec(item)">删除</el-button>
                    </div>
                </div>
                <div v-if="total>2 && total>tableData.length" id="loadingTips">
                    <i class="el-icon-loading"></i>&nbsp;信息加载中，请稍候...
                </div>
            </div>

            <el-dialog id="mainDialog" class="formDialog" :title="recordTableDialogTitle"
                       :visible.sync="recordTableDialogVisible" v-if="recordTableDialogVisible" width="90%" top="50px"
                       @close="queryList">
                <div style="height: 65vh;overflow: auto">
                    <recordTable ref="recordTable" :user-code="queryForm.userCode" :user-name="queryForm.userName"
                                 userType="tea" @callback="callback" type="mobile"
                                 :recType="recType" :id="id"/>
                </div>
                <div style="width:100%; text-align:center; margin-bottom:10px;margin-top: 10px">
                    <el-button type="primary" @click="saveRec">保 存</el-button>
                    <el-button @click="recordTableDialogVisible = false">关 闭</el-button>
                </div>
            </el-dialog>

            <el-dialog id="mainDialog" class="formDialog" title="批量导出" :visible.sync="batchExportDialogVisible"
                       width="90%" @closed="closeBatch">
                <el-form ref="batchForm" :model="batchForm" style="padding-left: 10px;padding-right: 10px">
                    <el-row>
                        <el-form-item label="开始日期" prop="beginDate" :rules="[{required: true, message: '请选择开始日期'}]">
                            <el-date-picker v-model="batchForm.beginDate" type="date" value-format="yyyy-MM-dd"
                                            placeholder="开始日期"/>
                        </el-form-item>
                    </el-row>
                    <el-row>
                        <el-form-item label="结束日期" prop="endDate" :rules="[{required: true, message: '请选择结束日期'}]">
                            <el-date-picker v-model="batchForm.endDate" type="date" value-format="yyyy-MM-dd"
                                            placeholder="结束日期"/>
                        </el-form-item>
                    </el-row>
                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align:center;">
                    <el-button type="primary" @click="batchExport()">确 定</el-button>
                    <el-button @click="batchExportDialogVisible = false">取 消</el-button>
                </div>
            </el-dialog>

        </div>
    </div>
</template>

<script>
import {globalConfig} from "../../../../static/config";
import recordTable from "../../../../src/views/postPracticeManage/recordTable";
import {confirmMsg, showNotify} from "../../../utils/message";

export default {
    props: ['divHeight'],
    components: {
        recordTable
    },
    data() {
        return {
            queryForm: {
                pageNum: 1,
                rowNum: 20,
                userCode: '',
                userName: '',
                userRoles: [],
                unitName: '',
                postName: '',
                admin:'false'
            },
            //表格数据
            tableData: [],
            //选中行的数据
            selectRowData: null,
            tableLoading: true,
            total: null,
            currentPage: 1,
            mainTableHeight: 500,
            comboOption: {},
            queryDialogVisible: false,
            detailDialogVisible: false,
            recordTableDialogVisible: false,
            recType: '',
            recordTableDialogTitle: '',
            id: '',
            batchExportDialogVisible: false,
            batchForm: {
                beginDate: '',
                endDate: ''
            },
            loadingMask: null
        }

    },
    mounted() {
        this.queryForm.userCode = this.userCode
        this.queryForm.userRoles = this.userRoles
        this.userInfo()
    },
    methods: {
        delFile(){
            this.$api.postPracticeManage.siteInstruction.delFile({
                data: this.queryForm.userCode
            }).then((res) => {
            }).catch((error) => {
            });
        },
        closeBatch() {
            this.delFile()
            if (this.$refs['batchForm'] !== undefined) {
                this.$refs['batchForm'].clearValidate();
                this.$refs['batchForm'].resetFields();
            }
        },
        batchExport() {
            this.$refs['batchForm'].validate((valid) => {
                if (valid) {
                    let form = {
                        userCode: this.queryForm.userCode,
                        beginDate: this.batchForm.beginDate,
                        endDate: this.batchForm.endDate,
                        admin: this.queryForm.admin
                    }
                    this.$api.postPracticeManage.siteInstruction.exportMobile({
                        data: form
                    }).then((res) => {
                        if(res.data.data === 'none'){
                            showNotify('失败', "暂无可导出现场指导信息", 'error', 3000);
                        }else {
                            this.fileDownload(res.data.data)
                        }
                    }).catch((err) => {
                        console.log(err);
                    });
                } else {
                    return false;
                }
            });
        },
        fileDownload(path) {
            const fileUrl = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi;
            let exist = this.isExistFile(fileUrl + path);
            if (exist) {
                let furl = fileUrl + path;
                //创建隐藏的下载链接
                const link = document.createElement('a');
                link.href = furl;
                // link.target = '_blank';
                // let fileName = rowData.fileName + '.' + rowData.fileType;
                // link.setAttribute('download', fileName);
                // 兼容性处理
                if (navigator.userAgent.indexOf('Trident') > -1) { // IE浏览器
                    const ieDownloadFrame = document.createElement('iframe');
                    ieDownloadFrame.src = furl;
                    ieDownloadFrame.style.display = 'none';
                    document.body.appendChild(ieDownloadFrame);
                } else if (navigator.userAgent.indexOf('Edge') > -1 || navigator.userAgent.indexOf('Edg') > -1) { // Edge浏览器
                    link.click(); // 直接触发链接点击事件
                } else { // 其他浏览器
                    link.dispatchEvent(new MouseEvent('click'));
                }
            }
        },
        isExistFile(url) {
            if (url == null || url == undefined || url == "") {
                return false;
            }
            let xmlhttp;
            if (window.XMLHttpRequest) {
                xmlhttp = new XMLHttpRequest();
            } else {
                xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
            }
            xmlhttp.open("GET", url, false);
            xmlhttp.send();
            if (xmlhttp.readyState == 4) {
                if (xmlhttp.status == 200) return true;
                //url存在
                else if (xmlhttp.status == 404) return false;
                //url不存在
                else return false; //其他状态
            }
        },
        showLoadingMask(str) {
            this.loadingMask = this.$loading({
                lock: true,
                text: str,
                spinner: "el-icon-loading",
                background: "rgba(0, 0, 0, 0.8)",
            });
        },
        /**关闭loading**/
        closeLoadingMask() {
            if (this.loadingMask) this.loadingMask.close();
        },
        delRec(rowData) {
            confirmMsg('是否确定要删除现场指导表？', 'el-message-box-mobile').then(() => {
                this.$api.postPracticeManage.siteInstruction.del({
                    data: rowData.id,
                }).then((res) => {
                    if (res.data.data === 'success') {
                        showNotify('成功', "删除成功", 'success', 1500);
                        this.queryList();
                    } else {
                        showNotify('失败', "删除失败", 'error', 3000);
                    }
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            });
        },
        modRec(rowData) {
            this.recType = 'mod'
            this.id = rowData.id
            this.recordTableDialogVisible = true
        },
        saveRec() {
            this.$refs.recordTable.saveRec()
        },
        callback() {
            this.requeryList()
            this.recordTableDialogVisible = false
        },
        addRec() {
            this.recType = 'add'
            this.recordTableDialogVisible = true
        },
        userInfo() {
            this.$api.system.basic.userInfo({})
                .then((res) => {
                    this.queryForm.userCode = res.data.data.phone;
                    this.queryForm.userName = res.data.data.name;
                    let arr = []
                    for (let roleCode in res.data.data.roles) {
                        if (roleCode === globalConfig.auth.admin || roleCode === globalConfig.auth.jwy_sx || roleCode === globalConfig.auth.fdy || roleCode === globalConfig.auth.sx_xbgly || roleCode === globalConfig.auth.sx_zyzdjs) {
                            arr.push(roleCode)
                        }

                        if(roleCode === globalConfig.auth.admin || roleCode === globalConfig.auth.jwy_sx){
                            this.queryForm.admin = 'true'
                        }
                    }
                    this.queryForm.userRoles = arr
                    // this.queryForm.userCode = '096136'
                    // this.queryForm.userRoles = []
                    // this.queryForm.userRoles.push(globalConfig.auth.jwy_sx)
                    // this.queryForm.userRoles.push('7')
                    // this.queryForm.userRoles.push('22')
                    this.queryList()
                    this.delFile()
                }).catch((err) => {
                console.log(err);
            });
        },
        async queryList() {
            this.tableLoading = true;
            this.queryForm.pageNum = this.currentPage;

            await this.$api.postPracticeManage.siteInstruction.queryList({
                data: this.queryForm,
            }).then((response) => {
                this.total = response.data.data.total;
                this.tableData = this.tableData.concat(response.data.data.list);
                this.tableLoading = false;
            }).catch((error) => {
                this.tableLoading = false;
                console.log(error);
            });
        },
        handleFilter() {
            this.requeryList();
            this.queryDialogVisible = false;
        },
        requeryList() {
            this.scrollToTop();
            this.tableData.length = 0;
            this.currentPage = 1;
            this.queryList();
        },
        scrollToTop() {
            const ele = document.getElementById('listArea');
            if (ele) {
                ele.scrollTop = 0;
            }
        },
        handleReset() {
            this.requeryList();
            this.queryDialogVisible = false;
        },
        handleScroll() {
            if (this.checkVisible() && !this.tableLoading && this.total > this.tableData.length) {
                this.currentPage++;
                this.queryList();
            }
        },
        checkVisible() {
            const ele = document.getElementById('loadingTips');
            if (ele) {
                let rect = ele.getBoundingClientRect();
                //获取当前浏览器的视口高度，不包括工具栏和滚动条
                //document.documentElement.clientHeight兼容 Internet Explorer 8、7、6、5
                let viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight);
                //bottom top是相对于视口的左上角位置
                //bottom大于0或者top-视口高度小于0可见
                return !(rect.bottom < 0 || rect.top - viewHeight >= 0);
            } else {
                return false;
            }
        },


    }
}
</script>


<style src="styles/mobile.css"></style>
<style scoped>
#mobileMode {
    width: auto;
}

#mobileMode #queryDialog {
    top: 130px;
}

#mobileMode #mainDialogScroll {
    height: 65vh;
    padding: 10px 20px;
}

#mobileMode #loadingTips {
    height: 30px;
    line-height: 30px;
    color: #9d9d9d;
    position: relative;
    bottom: 0;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// reportMobile.vue?0af39b41